/* 
 * @description: 
 * @author: Jason Wong 
 * @since: 2019-12-18 18:32:09 
 */

export default {
    install(vue, options) {
        vue.prototype.$loading = function () { }
        vue.prototype.$alert = function () { }
        vue.prototype.$message = function () { }
        vue.prototype.$confirm = function () { }
        vue.prototype.$prompt = function () { }
        vue.prototype.$msgbox = function () { }
        vue.prototype.$notify = function () { }
    }
}